

































































































































































































































































































































































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import LineChart from "@/assets/chart/home/LineChart.js";
import Bar from "@/assets/chart/home/Bar.js";
import Pie from "@/assets/chart/home/Pie.js";

@Component({
  components: {
    LineChart,
    Bar,
    Pie,
  },
})
export default class Monitoring extends AbpBase {
  datacollection1: any = null;
  options1: any = null;
  datacollection2: any = null;
  datacollection3: any = null;
  options2: any = null;
  fillData() {
    this.datacollection1 = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      datasets: [
        {
          label: "Data One",
          borderColor: "#4d8cf4",
          data: [0, 5, 3, 7, 5, 10, 3, 6, 5, 10],
          pointRadius: 0,
          fill: false,
          tension: 0,
          borderWidth: 1,
        },
      ],
    };
    this.options1 = {
      legend: { display: false },
      scales: {
        yAxes: [
          {
            ticks: { beginAtZero: true },
            display: false,
          },
        ],
        xAxes: [
          {
            barPercentage: 1,
            categoryPercentage: 1,
            display: false,
          },
        ],
      },
      tooltips: {
        enabled: false,
      },
    };

    this.datacollection2 = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      datasets: [
        {
          borderColor: "#00bf4f",
          backgroundColor: "#00bf4f",
          data: [1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14],
          barThickness: 5,
        },
      ],
    };
    this.datacollection3 = {
      labels: ["Red", "Orange", "Yellow", "Green", "Blue"],
      datasets: [
        {
          data: [30, 40, 30, 40, 50],
          backgroundColor: ["red", "orange", "yellow", "green", "blue"],
          label: "Dataset 1",
        },
      ],
    };
  }
  created() {
    this.fillData();
  }
}
